import React from "react";
import { Building2 } from "lucide-react";
import guestBg from "../../assets/images/guest-bg.jpg";
import LiveCallPanel from "@/components/calls/LiveCallPanel.jsx";

const cleanImageValue = (value) => {
  if (!value) return "";
  if (String(value).trim().toLowerCase() === "string") return "";
  return value;
};

const GuestLayout = ({ children, hotel, room, session, maxWidth = "max-w-4xl" }) => {
  const guestBackgroundImage =
    cleanImageValue(hotel?.backgroundImage) ||
    cleanImageValue(hotel?.BackgroundImage) ||
    guestBg;

  const hotelLogo =
    cleanImageValue(hotel?.appLogo) ||
    cleanImageValue(hotel?.AppLogo) ||
    cleanImageValue(hotel?.imageUrl) ||
    cleanImageValue(hotel?.ImageUrl) ||
    cleanImageValue(hotel?.logo) ||
    cleanImageValue(hotel?.Logo);

  return (
    <div className="relative min-h-screen overflow-x-hidden bg-[#121915] text-slate-900 selection:bg-[#923536]/20">
      {/* Background Image */}
      <div
        className="pointer-events-none fixed inset-0 z-0"
        style={{
          backgroundImage: `url(${guestBackgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          opacity: 0.78,
          filter: "saturate(1.26) contrast(1.08) brightness(0.85)",
        }}
      />

      {/* Gradient Overlays */}
      <div className="pointer-events-none fixed inset-0 z-0 bg-[linear-gradient(180deg,rgba(8,12,18,0.28)_0%,rgba(8,12,18,0.15)_35%,rgba(8,12,18,0.38)_100%)]" />
      <div className="pointer-events-none fixed inset-0 z-0 bg-[radial-gradient(circle_at_top_center,rgba(255,255,255,0.18)_0%,rgba(0,0,0,0.25)_100%)]" />

      <div className="relative z-10 flex min-h-screen flex-col">
        {/* iOS Glass Header */}
        <header className="sticky top-0 z-30 border-b border-white/25 bg-white/85 shadow-sm backdrop-blur-2xl transition-colors duration-200">
          <div className={`mx-auto flex ${maxWidth} items-center justify-between gap-3 px-4 py-2.5 sm:px-6 sm:py-3`}>
            <div className="flex min-w-0 items-center gap-2.5 sm:gap-3">
              {hotelLogo ? (
                <img
                  src={hotelLogo}
                  alt={hotel?.name || "Hotel"}
                  className="h-9 w-9 rounded-xl object-cover ring-1 ring-black/5 shadow-sm sm:h-10 sm:w-10 sm:rounded-2xl"
                />
              ) : (
                <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#923536] text-white shadow-sm ring-1 ring-white/20 sm:h-10 sm:w-10 sm:rounded-2xl">
                  <Building2 className="h-5 w-5" />
                </div>
              )}

              <div className="min-w-0 flex-1">
                <h1 className="truncate text-sm font-bold text-slate-900 leading-tight sm:text-base">
                  {hotel?.name || hotel?.Name || "Hotel"}
                </h1>

                <p className="truncate text-[11px] font-medium text-slate-500 sm:text-xs">
                  {room?.roomNumber || room?.name || room?.Name
                    ? `Room ${room?.roomNumber || room?.name || room?.Name}`
                    : "Guest Portal"}
                </p>
              </div>
            </div>

            <div className="shrink-0">
              <LiveCallPanel
                mode="guest"
                guestInfo={{
                  sessionId:
                    session?.sessionId ||
                    session?.SessionId ||
                    session?.id ||
                    session?.Id ||
                    session?.guestSessionId ||
                    session?.GuestSessionId ||
                    "",
                  guestName:
                    session?.guestName ||
                    session?.GuestName ||
                    session?.fullName ||
                    session?.FullName ||
                    session?.name ||
                    "Guest",
                  roomName:
                    room?.roomNumber ||
                    room?.RoomNumber ||
                    room?.name ||
                    room?.Name ||
                    session?.roomName ||
                    session?.RoomName ||
                    "",
                  organizationId:
                    session?.organizationId ||
                    session?.OrganizationId ||
                    hotel?.id ||
                    hotel?.Id ||
                    "",
                }}
              />
            </div>
          </div>
        </header>

        {/* Content with safe area bottom padding for iOS Safari floating bar */}
        <main className={`mx-auto w-full ${maxWidth} flex-1 px-3.5 py-4 pb-32 sm:px-6 sm:py-7 sm:pb-24`}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default GuestLayout;
